import { render, staticRenderFns } from "./ClinicTemplates.vue?vue&type=template&id=54813672"
import script from "./ClinicTemplates.vue?vue&type=script&lang=js"
export * from "./ClinicTemplates.vue?vue&type=script&lang=js"
import style0 from "./ClinicTemplates.vue?vue&type=style&index=0&id=54813672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports